import { useMutation } from 'react-query';
import request from '../../../../../../helpers/request';
import { useDispatch } from 'react-redux';
import { fetchShutdownsThunk } from '../../../../shared/model/actions';

const changeReason = async ({ shutdownId, data }) => {
  const res = await request.put(
    `/Alert/reason/${shutdownId}`,
    data,
    'Не удалось сохранить причину отключения',
    'Error'
  );

  return res;
};

export const useShutdownReasonChange = (options = {}) => {
  const dispatch = useDispatch();

  const changeMutation = useMutation(changeReason, {
    ...options,
    onSuccess: (res, { shutdownId, data }) => {
      if (res !== 'Error') {
        dispatch(fetchShutdownsThunk());
      }
    },
  });

  return {
    change: changeMutation.mutateAsync,
    loading: changeMutation.isLoading,
  };
};
